module.exports = __webpack_public_path__ + "zvetseni-prsou_33_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_33_after.jpg
// module id = 1327
// module chunks = 0